import { ChangeDetectionStrategy, Component, Directive, TemplateRef, ViewEncapsulation, contentChild, contentChildren, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({ selector: '[wbCardIdentifier]', standalone: true })
export class CardIdentifierDirective { }

@Directive({ selector: '[wbCardTitle]', standalone: true })
export class CardTitleDirective { }

@Directive({ selector: '[wbCardDescription]', standalone: true })
export class CardDescriptionDirective { }

@Directive({ selector: '[wbCardStatus]', standalone: true })
export class CardStatusDirective { }

@Directive({ selector: '[wbCardRow]', standalone: true })
export class CardRowDirective { }

@Directive({ selector: '[wbCardFooter]', standalone: true })
export class CardFooterDirective { }

@Component({
  selector: 'wb-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./card.component.less'],
  host: {
    '[class.wb-card-clickable]': '$clickable()',
    '[class.wb-card-disabled]': '$disabled()',
    '[class.wb-card-selected]': '$selected()',
    '[class.wb-card-compact]': '$compact()',
  },
  template: `
    <div class="wb-card-header">
      <div class="wb-card-header-top">
        @if ($identifierTpl()) {
          <div class="wb-card-identifier"><ng-container *ngTemplateOutlet="$identifierTpl()" /></div>
        } @else if ($identifier()) {
          <div class="wb-card-identifier">{{ $identifier() }}</div>
        }

        @if ($statusTpl()) {
          <div class="wb-card-status"><ng-container *ngTemplateOutlet="$statusTpl()" /></div>
        }
      </div>

      @if ($titleTpl() || $title() || $descriptionTpl() || $description()) {
        <div class="wb-card-title-group">
          @if ($titleTpl()) {
            <div class="wb-card-title"><ng-container *ngTemplateOutlet="$titleTpl()" /></div>
          } @else if ($title()) {
            <div class="wb-card-title">{{ $title() }}</div>
          }

          @if ($descriptionTpl()) {
            <div class="wb-card-description"><ng-container *ngTemplateOutlet="$descriptionTpl()" /></div>
          } @else if ($description()) {
            <div class="wb-card-description">{{ $description() }}</div>
          }
        </div>
      }
    </div>

    @if ($rows().length > 0) {
      <div class="wb-card-body">
        @for (row of $rows(); track $index) {
          <div class="wb-card-row"><ng-container *ngTemplateOutlet="row" /></div>
        }
      </div>
    }

    @if ($footerTpl()) {
      <div class="wb-card-footer">
        <ng-container *ngTemplateOutlet="$footerTpl()" />
      </div>
    }
  `,
})
export class CardComponent {

  public $identifier = input<string>(null, { alias: 'identifier' });
  public $title = input<string>(null, { alias: 'title' });
  public $description = input<string>(null, { alias: 'description' });
  public $clickable = input(false, { alias: 'clickable' });
  public $disabled = input(false, { alias: 'disabled' });
  public $selected = input(false, { alias: 'selected' });
  public $compact = input(false, { alias: 'compact' });

  protected $identifierTpl = contentChild(CardIdentifierDirective, { read: TemplateRef });
  protected $titleTpl = contentChild(CardTitleDirective, { read: TemplateRef });
  protected $descriptionTpl = contentChild(CardDescriptionDirective, { read: TemplateRef });
  protected $statusTpl = contentChild(CardStatusDirective, { read: TemplateRef });
  protected $rows = contentChildren(CardRowDirective, { descendants: false, read: TemplateRef });
  protected $footerTpl = contentChild(CardFooterDirective, { read: TemplateRef });
}
